// Copyright (c) 2016 Deere & Company

import Customer, {getDefaultState as getCustomerDefaultState} from '@deere/cps-it.warranty-model-factory/lib/customer';

export const getDefaultState = () => getCustomerDefaultState();

export default Customer;



// WEBPACK FOOTER //
// ./src/pip/pip-code/state/customer.js